import { DivAlert } from "components/display/DivAlert";
import styled, { css } from "styled-components";

export const Wrapper = styled.div`
  height: 100%;
  overflow-y: hidden;

  form {
    display: flex;
    flex-direction: row;
    align-self: stretch;
    height: 100%;
    overflow-y: hidden;
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  width: 50%;
  padding: 2rem;

  &:first-of-type {
    border-right: 1px solid #3d3d3d;
  }
`;

type LabelButtonProps = {
  isFileSelected: boolean;
};

export const ImagePreview = styled.img`
  width: 150px;
  height: 150px;
  border-radius: 10px;
`;

export const LabelButton = styled.div<LabelButtonProps>`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;

  background-color: var(--black-300);
  border-radius: 10px;
  cursor: pointer;
  border: 2px dashed var(--grey-300);

  input {
    display: none;
  }

  p {
    max-width: 300px;

    white-space: nowrap;
    overflow: hidden;
    padding-right: 1.2rem;
    text-overflow: ellipsis;
  }

  span {
    color: var(--grey-100);

    margin-bottom: 1.4rem;
    margin-top: 0.5rem;
  }

  > div {
    display: flex;
    flex-direction: column;
    align-items: center;

    p {
      margin-top: 0.8rem;
    }
  }
  ${({ isFileSelected }) =>
    isFileSelected &&
    css`
      background-color: var(--black-400);
    `};
`;

export const FormGroup = styled.div`
  width: 100%;
  margin-bottom: 1rem;

  .input-container input:disabled {
    width: 100%;
    background-color: var(--black-300);
    cursor: not-allowed;
  }

  button {
    width: 100%;
    margin-top: 1rem;

    &:hover {
      opacity: 0.8;
    }
  }
`;

export const CustomDivAlert = styled(DivAlert)`
  button {
    width: 100%;
    height: 40px;
    margin-top: 1rem;
    font-size: 0.9rem;

    &:hover {
      opacity: 0.8;
    }
  }
`;

export const PreviewContainer = styled.div`
  width: 100%;
  height: 20rem;
  padding: 1rem;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-template-rows: auto;
  place-items: center;
  column-gap: 0.3rem;
  row-gap: 1rem;
  overflow-y: auto;
  margin-bottom: 2rem;

  .image-preview-container {
    position: relative;
  }

  .trash-icon {
    background: var(--black-300);
    position: absolute;
    top: 0;
    right: 0;
    padding: 0.2rem;
    border-radius: 4px;
    opacity: 0.8;
    transition: all 0.3s ease-in-out;

    &:hover {
      opacity: 1;
    }
  }
`